import React, {
    useState,
    useEffect,
    Fragment,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Text, Title, Table, Group, Collapse, Box, Transition } from '@mantine/core'
import { FiDownload } from "react-icons/fi";
import { getData } from '../services/fetch-service';
import { toast, Notification } from 'components/ui'
import Comments from './Comments';
import { setKomentet, setRaportStatusId, setReferenceId } from '../store/dataslice';
import DetailsInput from '../shared/DetailsInput';
import dayjs from 'dayjs';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Fade } from '@mui/material';

const Search = () => {
    const dispatch = useDispatch();
    const baseUrl = process.env.REACT_APP_BASEURL
    const institutionsData = useSelector((state) => state.WebsiteLanguage.data.Instuticionet);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
    const AlertTranslations = useSelector((state) => state.WebsiteLanguage.data.AlertTranslations);
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);

    const [referenceNumber, setReferenceNumber] = useState('');
    const [datatable, setDataTable] = useState();
    const [showDetalis, setShowDetalis] = useState(false);
    const [sinjalizimiRaporte, setSinjalizimiRaporte] = useState();
    const [konflitiInteresitRaporte, setKonflitiInteresitRaporte] = useState();
    const [deklarimiRaporte, setDeklarimiRaporte] = useState();
    const [tjeraRaporte, settjeraRaporte] = useState();
    // const [llojiDeklarimit, setLlojiDeklarimit] = useState([]);
    const [searchClicked, setSearchClicked] = useState(false);
    const [konfliktndaj, setKonfliktndaj] = useState();
    const [llojiShkeljes, setLlojiShkeljes] = useState('');
    const [sinjalizmiEshteBere, setSinjalizmiEshteBere] = useState();
    const url = window.location.pathname.split('/Kerko/')[1];

    const institutionsDataWithStringValues = institutionsData.map(item => ({
        value: `${item.id}`,
        label: item.nameSq,
    }));

    institutionsDataWithStringValues.push({ value: '-1', label: 'Tjera' });

    let nameLocale = '';
    let pershkrimiLocale = '';
    let nameLocaleSinjalizimi = '';
    let nameLocaleKonfliktInteresi = '';
    let nameLocaleDekarimiDhuratave = '';
    let nameLocaleTjeter = '';

    if (WebsiteLanguage === 'sq') {
        nameLocale = 'nameSq';
        pershkrimiLocale = 'pershkrimiSq';
        nameLocaleSinjalizimi = `${GeneralTranslations.signal}`;
        nameLocaleKonfliktInteresi = `${GeneralTranslations.interestsConflict}`;
        nameLocaleDekarimiDhuratave = `${GeneralTranslations.DeklarimiPasurise}`;
        nameLocaleTjeter = `${GeneralTranslations.Other}`;
    } else if (WebsiteLanguage === 'en') {
        nameLocale = 'nameEn';
        pershkrimiLocale = 'pershkrimiEn';
        nameLocaleSinjalizimi = `${GeneralTranslations.signal}`;
        nameLocaleKonfliktInteresi = `${GeneralTranslations.interestsConflict}`;
        nameLocaleDekarimiDhuratave = `${GeneralTranslations.DeklarimiPasurise}`;
        nameLocaleTjeter = `${GeneralTranslations.Other}`;
    } else if (WebsiteLanguage === 'sr') {
        nameLocale = 'nameSr';
        pershkrimiLocale = 'pershkrimiSr';
        nameLocaleSinjalizimi = `${GeneralTranslations.signal}`;
        nameLocaleKonfliktInteresi = `${GeneralTranslations.interestsConflict}`;
        nameLocaleDekarimiDhuratave = `${GeneralTranslations.DeklarimiPasurise}`;
        nameLocaleTjeter = `${GeneralTranslations.Other}`;
    } else {
        nameLocale = 'nameSq';
        pershkrimiLocale = 'pershkrimiSq';
        nameLocaleSinjalizimi = `${GeneralTranslations.signal}`;
        nameLocaleKonfliktInteresi = `${GeneralTranslations.interestsConflict}`;
        nameLocaleDekarimiDhuratave = `${GeneralTranslations.DeklarimiPasurise}`;
        nameLocaleTjeter = `${GeneralTranslations.Other}`;
    };

    const [languageValue, setLanguageValue] = useState(1);

    useEffect(() => {
        const languageMap = {
            'sq': 1,
            'en': 2,
            'sr': 3
        };

        setLanguageValue(languageMap[WebsiteLanguage]);
    }, [WebsiteLanguage]);

    useEffect(() => {
        if (datatable && datatable.sinjalizimi) {
            if (datatable.sinjalizimi.perZyrtarPergjegjes) {
                setSinjalizmiEshteBere(GeneralTranslations.official);
            }
            else if (datatable.sinjalizimi.perPunedhenes) {
                setSinjalizmiEshteBere(GeneralTranslations.employer);
            }
        }
        if (datatable && datatable.konfliktInteresit) {
            if (datatable.konfliktInteresit.ndajZyrtarit) {
                setKonfliktndaj("1");
            }
            else if (datatable.konfliktInteresit.ndajOrganitKolegjial) {
                setKonfliktndaj("2");
            }
        }
        if (datatable && datatable.deklarimi) {
            if (datatable.deklarimi.mosDeklarimiPasurise) {
                setLlojiShkeljes("1");
            }
            else if (datatable.deklarimi.mosDeklarimiDhuratave) {
                setLlojiShkeljes("2");
            }
        }
    }, [datatable]);

    let errorMessageDisplayed = false;
    const performInitialSearch = async () => {
        if (url !== undefined) {
            setReferenceNumber(url);
            try {
                const response = await getData(`Raportet/GetReportByReference?reference=${url}`);
                if (response.data) {
                    setDataTable(response.data.data);
                    dispatch(setKomentet(response.data.data.raportimetHistoria));
                    dispatch(setReferenceId(response.data.data.id));
                    dispatch(setRaportStatusId(response.data.data.statusiId));

                    setSearchClicked(true);
                    if (response.data.llojiDeklarimitPasurise) {
                        setLlojiDeklarimitPasurise(response.data.llojiDeklarimitPasurise);
                    }
                    if (response.data.data.sinjalizimi) {
                        setSinjalizimiZyrtare(response.data.data.sinjalizimi.sinjalizimiZyrtarets)
                    }
                }
            } catch (error) {
                setSearchLoad(false);
                if (error.response && error.response?.request?.statusText === 'Not Found' && !errorMessageDisplayed) {
                    errorMessageDisplayed = true;
                    toast.push(
                        <Notification title={`${AlertTranslations.notifyErrorSearch}`} type="info" duration={4000} />
                        , {
                            placement: 'top-end'
                        }
                    )
                }
                // setReferenceNumber('');
            }
        }
    };

    useEffect(() => {
        performInitialSearch();
    }, []);

    const [LlojiDeklarimitPasurise, setLlojiDeklarimitPasurise] = useState(null);
    const [sinjalizimiZyrtare, setSinjalizimiZyrtare] = useState(null);
    const [serachLoad, setSearchLoad] = useState(false);

    const handleSearch = async () => {
        try {
            if (referenceNumber !== '') {
                setSearchLoad(true);
                const response = await getData(`Raportet/GetReportByReference?reference=${referenceNumber}`);
                if (response.data) {
                    setSearchLoad(false);
                    setDataTable(response.data.data);
                    dispatch(setKomentet(response.data.data.raportimetHistoria));
                    dispatch(setReferenceId(response.data.data.id));
                    dispatch(setRaportStatusId(response.data.data.statusiId));
                    setSearchClicked(true);
                    if (response.data.llojiDeklarimitPasurise) {
                        setLlojiDeklarimitPasurise(response.data.llojiDeklarimitPasurise);
                    }
                    if (response.data.data.sinjalizimi) {
                        setSinjalizimiZyrtare(response.data.data.sinjalizimi.sinjalizimiZyrtarets)
                    }
                } else {
                    toast.push(
                        <Notification title={AlertTranslations.notifyErrorSearch} type="info" duration={3000} />
                        , {
                            placement: 'top-end'
                        }
                    )
                    setSearchLoad(false);
                    // setReferenceNumber('');
                    setSearchClicked(false);
                }
            }
        } catch (error) {
            if (error.response && error.response?.request?.statusText === 'Not Found') {
                toast.push(
                    <Notification title={AlertTranslations.notifyErrorSearch} type="info" duration={3000} />
                    , {
                        placement: 'top-end'
                    }
                )
            } else {
                toast.push(
                    <Notification title={AlertTranslations.notifyErrorSearch} type="info" duration={3000} />
                    , {
                        placement: 'top-end'
                    }
                )
            }
            setSearchLoad(false);
            // setReferenceNumber('');
            setSearchClicked(false);
        }
    };

    const handleCommentPosted = () => {
        handleSearch();
    };

    useEffect(() => {
        if (datatable?.raportimiLloji === 1) {
            setSinjalizimiRaporte(datatable.sinjalizimi)
        }
        else if (datatable?.raportimiLloji === 2) {
            setKonflitiInteresitRaporte(datatable.konfliktInteresit)
        }
        else if (datatable?.raportimiLloji === 3) {
            setDeklarimiRaporte(datatable.deklarimi)
        }
        else if (datatable?.raportimiLloji === 4) {
            settjeraRaporte(datatable.raportimetTjera)
        }
    }, [datatable]);

    const Komentet = useSelector((state) => state.WebsiteLanguage.data.Komentet);
    const path = process.env.REACT_APP_FILESPATH;

    const onDownload = (doc) => {
        const fileUrl = `${path}${doc.media?.fileName}${doc.media?.fileEx}`;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = doc.media.name.replace('.', '');
        link.target = '_blank';
        link.click();
    };

    const renderStatusHierarchy = (status, locale) => {
        const hierarchy = [];
        let current = status;

        while (current) {
            hierarchy.unshift(<div key={current.id}>{current[locale]}</div>);
            current = current.parent;
        }

        return hierarchy;
    };

    return (
        <div className="search-section">
            <div className="search-header">
                <div className="head-s">
                    <Title className="search-title" order={2}>{GeneralTranslations.searchReport}</Title>
                    <Text className="search-desc" size="md">{GeneralTranslations.searchSubject}</Text>
                </div>
                <div className="search-input">
                    <Input
                        size="md"
                        placeholder={ControlsTranslations.SearchButton}
                        value={referenceNumber}
                        onChange={(event) => setReferenceNumber(event.target.value)}
                    />
                    <Button
                        loading={serachLoad}
                        className="form-btn btn-search btn-search-report"
                        variant="filled"
                        onClick={handleSearch}
                    >{ControlsTranslations.SearchButton}</Button>
                </div>
            </div>

            {/* tabela kerkimit */}
            <Transition
                mounted={searchClicked}
                transition="fade"
                duration={300}
            // timingFunction="ease"
            >
                {(styles) => (
                    <div style={styles} className="search-table">
                        <div className="search-tabel-report">
                            <Table>
                                <thead className="table-head-report">
                                    <tr>
                                        <th className="table-head-th">{GeneralTranslations.reference}</th>
                                        <th className="table-head-th">{GeneralTranslations.LlojiRaportimitSearch}</th>
                                        <th className="table-head-th">{GeneralTranslations.reportDate}</th>
                                        <th className="table-head-th">{GeneralTranslations.statusSearch}</th>
                                        <th className="table-head-th"></th>
                                    </tr>
                                </thead>
                                <tbody stickyHeader>
                                    <tr>
                                        <td>{datatable?.referenca}</td>
                                        <td>{datatable?.raportimiLloji === 1
                                            ? [nameLocaleSinjalizimi]
                                            : datatable?.raportimiLloji === 2
                                                ? [nameLocaleKonfliktInteresi]
                                                : datatable?.raportimiLloji === 3
                                                    ? [nameLocaleDekarimiDhuratave]
                                                    : datatable?.raportimiLloji === 4
                                                        ? [nameLocaleTjeter]
                                                        : ""}</td>
                                        <td>
                                            {datatable?.created && new Date(datatable.created).toLocaleDateString('en-GB')}
                                        </td>
                                        {/* change statusi me map nga raportimi historia */}
                                        <td>
                                            {datatable?.statusi ? (
                                                renderStatusHierarchy(datatable.statusi, nameLocale)
                                            ) : (
                                                `${AlertTranslations.noStatus}`
                                            )}
                                        </td>
                                        <td className="table-head-td">
                                            <a
                                                href={`${baseUrl}Reports/FindReportReference?ReferencaRaportimit=${referenceNumber}&type=1&webLangId=${languageValue}`}
                                                target="_blank"
                                            >
                                                <Button
                                                    className="btn-table"
                                                    variant="filled"
                                                >{ControlsTranslations.downloadReport}</Button>
                                            </a>
                                            <Button
                                                className="btn-table"
                                                variant="filled"
                                                onClick={() => setShowDetalis(!showDetalis)}
                                            >{ControlsTranslations.shikoDetajet}</Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>

                            <Transition
                                mounted={showDetalis}
                                transition="fade"
                                duration={300}
                            // timingFunction="ease"
                            >
                                {(styles) => (
                                    <div style={styles} className="search-input-report">
                                        <div className="search-textinput-report">
                                            <div className="details-header">
                                                <Title className="details-title" order={3}>{ControlsTranslations.shikoDetajet}</Title>
                                            </div>
                                            {sinjalizimiRaporte && datatable && datatable.sinjalizimi && (
                                                <Fragment>
                                                    {datatable.sinjalizimi.raportuesiAnonim !== true ? (
                                                        <Fragment>
                                                            <Title className="details-title cl-main" order={5}>{GeneralTranslations.reporter}</Title>
                                                            {datatable.sinjalizimi.raportuesiEmri || datatable.sinjalizimi.raportuesiMbiemri ?
                                                                (
                                                                    <Group className='group-search' grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.name}
                                                                            value={datatable.sinjalizimi.raportuesiEmri}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.lastName}
                                                                            value={datatable.sinjalizimi.raportuesiMbiemri}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            {datatable.sinjalizimi.raportuesiNrTel || datatable.sinjalizimi.raportuesiEmail ?
                                                                (
                                                                    <Group className='group-search' grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.numriTelefonit}
                                                                            value={datatable.sinjalizimi.raportuesiNrTel}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emailAddress}
                                                                            value={datatable.sinjalizimi.raportuesiEmail}
                                                                        />
                                                                    </Group>
                                                                ) : ''

                                                            }
                                                            <DetailsInput
                                                                label={GeneralTranslations.gender}
                                                                type="Gender"
                                                                value={datatable.sinjalizimi.raportuesiGjiniaId}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.institutionLabel}
                                                                value={datatable.sinjalizimi.raportuesiInstitucioni ? datatable.sinjalizimi.raportuesiInstitucioni[nameLocale] : null}
                                                            />
                                                            {datatable.sinjalizimi.raportuesiInstitucioniId === '-1' && (
                                                                <DetailsInput
                                                                    label={GeneralTranslations.institutionName}
                                                                    value={datatable.sinjalizimi.raportuesiInstitucioniTjera}
                                                                />
                                                            )}
                                                            <DetailsInput
                                                                label={GeneralTranslations.signalContent}
                                                                value={datatable.sinjalizimi.permbajtjaSinjalizimi ? datatable.sinjalizimi.permbajtjaSinjalizimi[pershkrimiLocale] : null}
                                                            />
                                                            <Fragment>
                                                                <DetailsInput
                                                                    label={GeneralTranslations.internalSignal}
                                                                    type="Bool"
                                                                    value={datatable.sinjalizimi.sinjalizimiBrendshemKryer}
                                                                />
                                                                {datatable.sinjalizimi.sinjalizimiBrendshemKryer === true &&
                                                                    <Fragment>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.signalDate}
                                                                            value={datatable.sinjalizimi.dataSinjalizimit ? dayjs(datatable.sinjalizimi.dataSinjalizimit).format('DD/MM/YYYY') : null}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.doneSignal}
                                                                            value={sinjalizmiEshteBere}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.epilogu}
                                                                            value={datatable.sinjalizimi.epilo ? datatable.sinjalizimi.epilo[nameLocale] : null}
                                                                        />
                                                                    </Fragment>
                                                                }
                                                                {datatable.sinjalizimi.sinjalizimiBrendshemKryer === false &&
                                                                    <DetailsInput
                                                                        label={GeneralTranslations.reasonReport}
                                                                        value={datatable.sinjalizimi.sinjalizimiBrendshemPaKryerKoment ? datatable.sinjalizimi.sinjalizimiBrendshemPaKryerKoment : null}
                                                                    />
                                                                }
                                                            </Fragment>
                                                        </Fragment>
                                                    ) : ''}
                                                    {sinjalizimiZyrtare?.map((data, index) => (
                                                        <div className="form-zyrtari" key={index}>
                                                            <Title className="details-title cl-main mtw-5 mbzyrtari" order={5}>{GeneralTranslations.zyrtari} {index + 1}</Title>
                                                            {data.emri || data.mbiemri ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emriZyrtarit}
                                                                            value={data.emri}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.mbiemriZyrtarit}
                                                                            value={data.mbiemri}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            {data.nrTel || data.email ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.officialNumber}
                                                                            value={data.nrTel}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emailAddress}
                                                                            value={data.email}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            <DetailsInput
                                                                label={GeneralTranslations.gender}
                                                                type="Gender"
                                                                value={data.gjiniaId}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.institutionLabel}
                                                                value={data.institucioni ? data.institucioni[nameLocale] : null}
                                                            />
                                                            {data.institucioniId === null && (
                                                                <DetailsInput
                                                                    label={GeneralTranslations.institutionName}
                                                                    value={data.institucioniTjera}
                                                                />
                                                            )}
                                                            <DetailsInput
                                                                label={GeneralTranslations.jobPosition}
                                                                value={data.pozitaPunes}
                                                            />
                                                        </div>
                                                    ))}

                                                    {datatable.raportimetMedia && datatable.raportimetMedia.length > 0 && (
                                                        <div className="details-docs">
                                                            <Title className="details-title cl-second mtw-5" order={5}>{GeneralTranslations.documents}</Title>
                                                            <Table aria-label="simple table" className="table-raportimet">
                                                                <TableHead>
                                                                    <TableRow className="header-table">
                                                                        <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                                        <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                                        <TableCell className="header-th"></TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {datatable.raportimetMedia.map((doc, index) => (
                                                                        (doc.dokumentShtese === true || (doc.raportimetNeProcedureHetimoreId === null && doc.raportimiHistoriaId === null)) && (

                                                                            <TableRow key={index} className="body-table">
                                                                                <TableCell >{index + 1}</TableCell>
                                                                                <TableCell >{doc.emertimi}{doc.media.fileEx}</TableCell>
                                                                                <TableCell ><FiDownload className="cursor-pointer" onClick={() => onDownload(doc)} /></TableCell>
                                                                            </TableRow>
                                                                        )))}
                                                                </TableBody>
                                                            </Table>

                                                        </div>
                                                    )}
                                                </Fragment>
                                            )}
                                            {konflitiInteresitRaporte && datatable && datatable.konfliktInteresit && (
                                                <Fragment>
                                                    {datatable.konfliktInteresit.raportuesiAnonim !== true ? (
                                                        <Fragment>
                                                            <Title className="details-title cl-main" order={5}>{GeneralTranslations.reporter}</Title>
                                                            {datatable.konfliktInteresit.raportuesiEmri || datatable.konfliktInteresit.raportuesiMbiemri ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.name}
                                                                            value={datatable.konfliktInteresit.raportuesiEmri}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.lastName}
                                                                            value={datatable.konfliktInteresit.raportuesiMbiemri}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            {datatable.konfliktInteresit.raportuesiNrTel || datatable.konfliktInteresit.raportuesiEmail ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.numriTelefonit}
                                                                            value={datatable.konfliktInteresit.raportuesiNrTel}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emailAddress}
                                                                            value={datatable.konfliktInteresit.raportuesiEmail}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            <DetailsInput
                                                                label={GeneralTranslations.gender}
                                                                type="Gender"
                                                                value={datatable.konfliktInteresit.raportuesiGjiniaId}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.conflictAgainst}
                                                                type="KonfliktNdaj"
                                                                value={konfliktndaj === '1' ? GeneralTranslations.officer : konfliktndaj === '2' ? GeneralTranslations.collegiateBody : ''}
                                                            />
                                                        </Fragment>
                                                    ) : ''}

                                                    {konfliktndaj === "1" ? (
                                                        <Fragment>
                                                            <Title className="details-title cl-main mtw-5" order={5}>{GeneralTranslations.zyrtari}</Title>
                                                            {datatable.konfliktInteresit.zyrtariEmri || datatable.konfliktInteresit.zyrtariMbiemri ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emriZyrtarit}
                                                                            value={datatable.konfliktInteresit.zyrtariEmri}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.mbiemriZyrtarit}
                                                                            value={datatable.konfliktInteresit.zyrtariMbiemri}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            {datatable.konfliktInteresit.zyrtariNrTel || datatable.konfliktInteresit.zyrtariEmail ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.officialNumber}
                                                                            value={datatable.konfliktInteresit.zyrtariNrTel}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emailAddress}
                                                                            value={datatable.konfliktInteresit.zyrtariEmail}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            <DetailsInput
                                                                label={GeneralTranslations.gender}
                                                                type="Gender"
                                                                value={datatable.konfliktInteresit.zyrtariGjiniaId}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.institutionLabel}
                                                                value={datatable.konfliktInteresit.zyrtariInstitucioni ? datatable.konfliktInteresit.zyrtariInstitucioni[nameLocale] : null}
                                                            />
                                                            {datatable.konfliktInteresit.zyrtariInstitucioniId === '-1' && (
                                                                <DetailsInput
                                                                    label={GeneralTranslations.institutionName}
                                                                    value={datatable.konfliktInteresit.zyrtariInstitucioniTjera}
                                                                />
                                                            )}
                                                            <DetailsInput
                                                                label={GeneralTranslations.jobPosition}
                                                                value={datatable.konfliktInteresit.zyrtariPozitaPunes}
                                                            />
                                                        </Fragment>
                                                    ) : konfliktndaj === "2" ? (
                                                        <Fragment>
                                                            <DetailsInput
                                                                label={GeneralTranslations.organName}
                                                                value={datatable.konfliktInteresit.emertimiOrganitKolegjial}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.institutionOrgan}
                                                                value={datatable.konfliktInteresit.organiKolegjialInstitucioni ? datatable.konfliktInteresit.organiKolegjialInstitucioni[nameLocale] : null}
                                                            />
                                                            {datatable.organiKolegjialInstitucioniId === '-1' && (
                                                                <DetailsInput
                                                                    label={GeneralTranslations.institutionName}
                                                                    value={datatable.konfliktInteresit.organiKolegjialInstitucioniTjeter}
                                                                />
                                                            )}
                                                        </Fragment>
                                                    ) : ''}

                                                    <DetailsInput
                                                        label={GeneralTranslations.timeCase}
                                                        value={datatable.konfliktInteresit.dataNdodhjesRastit ? dayjs(datatable.konfliktInteresit.dataNdodhjesRastit).format('DD/MM/YYYY') : null}
                                                    />
                                                    <DetailsInput
                                                        label={GeneralTranslations.sameProcedure}
                                                        type="Bool"
                                                        value={datatable.konfliktInteresit.procedureNgjashmeNeProces}
                                                    />
                                                    {datatable.konfliktInteresit.procedureNgjashmeNeProces === true &&
                                                        <DetailsInput
                                                            label={GeneralTranslations.infoDescription}
                                                            value={datatable.konfliktInteresit.procedureNgjashmeInfoShtese}
                                                        />
                                                    }
                                                    <DetailsInput
                                                        label={GeneralTranslations.caseDescription}
                                                        value={datatable.konfliktInteresit.pershkrimi}
                                                    />
                                                    {datatable.raportimetMedia && datatable.raportimetMedia.length > 0 && (
                                                        <div className="details-docs">
                                                            <Title className="details-title cl-second mtw-5" order={5}>{GeneralTranslations.documents} </Title>
                                                            <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                                                <TableHead>
                                                                    <TableRow className="header-table">
                                                                        <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                                        <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                                        <TableCell className="header-th"></TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {datatable.raportimetMedia.map((doc, index) => (
                                                                        (doc.dokumentShtese === true || (doc.raportimetNeProcedureHetimoreId === null && doc.raportimiHistoriaId === null)) && (

                                                                            <TableRow key={index} className="body-table">
                                                                                <TableCell >{index + 1}</TableCell>
                                                                                <TableCell >{doc.emertimi}{doc.media.fileEx}</TableCell>
                                                                                <TableCell ><FiDownload className="cursor-pointer" onClick={() => onDownload(doc)} /></TableCell>
                                                                            </TableRow>
                                                                        )))}
                                                                </TableBody>
                                                            </Table>
                                                        </div>
                                                    )}
                                                </Fragment>
                                            )}
                                            {deklarimiRaporte && datatable && datatable.deklarimi && (
                                                <Fragment>
                                                    {datatable.deklarimi.raportuesiAnonim !== true ? (
                                                        <Fragment>
                                                            <Title className="details-title cl-main" order={5}>{GeneralTranslations.reporter}</Title>
                                                            {datatable.deklarimi.raportuesiEmri || datatable.deklarimi.raportuesiMbiemri ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.name}
                                                                            value={datatable.deklarimi.raportuesiEmri}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.lastName}
                                                                            value={datatable.deklarimi.raportuesiMbiemri}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            {datatable.deklarimi.raportuesiNrTel || datatable.deklarimi.raportuesiEmail ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.numriTelefonit}
                                                                            value={datatable.deklarimi.raportuesiNrTel}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emailAddress}
                                                                            value={datatable.deklarimi.raportuesiEmail !== '' || datatable.deklarimi.raportuesiEmail !== null ? datatable.deklarimi.raportuesiEmail : null}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            <DetailsInput
                                                                label={GeneralTranslations.gender}
                                                                type="Gender"
                                                                value={datatable.deklarimi.raportuesiGjiniaId}
                                                            />
                                                        </Fragment>
                                                    ) : ''}
                                                    <Fragment>
                                                        <Title className="details-title cl-main mtw-5" order={5}>{GeneralTranslations.zyrtari}</Title>
                                                        {datatable.deklarimi.zyrtariEmri || datatable.deklarimi.zyrtariMbiemri ?
                                                            (
                                                                <Group grow>
                                                                    <DetailsInput
                                                                        label={GeneralTranslations.emriZyrtarit}
                                                                        value={datatable.deklarimi.zyrtariEmri}
                                                                    />
                                                                    <DetailsInput
                                                                        label={GeneralTranslations.mbiemriZyrtarit}
                                                                        value={datatable.deklarimi.zyrtariMbiemri}
                                                                    />
                                                                </Group>
                                                            ) : ''
                                                        }
                                                        {datatable.deklarimi.zyrtariNrTel || datatable.deklarimi.zyrtariEmail ?
                                                            (
                                                                <Group grow>
                                                                    <DetailsInput
                                                                        label={GeneralTranslations.officialNumber}
                                                                        value={datatable.deklarimi.zyrtariNrTel}
                                                                    />
                                                                    <DetailsInput
                                                                        label={GeneralTranslations.emailAddress}
                                                                        value={datatable.deklarimi.zyrtariEmail !== '' || datatable.deklarimi.zyrtariEmail !== null ? datatable.deklarimi.zyrtariEmail : null}
                                                                    />
                                                                </Group>
                                                            ) : ''
                                                        }
                                                        <DetailsInput
                                                            label={GeneralTranslations.gender}
                                                            type="Gender"
                                                            value={datatable.deklarimi.zyrtariGjiniaId}
                                                        />
                                                        <DetailsInput
                                                            label={GeneralTranslations.institutionLabel}
                                                            value={datatable.deklarimi.zyrtariInstitucioni ? datatable.deklarimi.zyrtariInstitucioni[nameLocale] : null}
                                                        />
                                                        {datatable.deklarimi.zyrtariInstitucioniId === '-1' && (
                                                            <DetailsInput
                                                                label={GeneralTranslations.institutionName}
                                                                value={datatable.deklarimi.zyrtariInstitucioniTjera}
                                                            />
                                                        )}
                                                        <DetailsInput
                                                            label={GeneralTranslations.jobPosition}
                                                            value={datatable.deklarimi.zyrtariPozitaPunes}
                                                        />
                                                    </Fragment>
                                                    <DetailsInput
                                                        label={GeneralTranslations.caseDescription}
                                                        value={datatable.deklarimi.pershkrimi}
                                                    />
                                                    <DetailsInput
                                                        label={GeneralTranslations.typeViolation}
                                                        type="LlojiShkeljes"
                                                        value={llojiShkeljes}
                                                    />
                                                    {llojiShkeljes === "1" ? (
                                                        <Fragment>
                                                            <Title className="details-title cl-second mtw-5" order={5}>{GeneralTranslations.wealthType} </Title>
                                                            {LlojiDeklarimitPasurise.map((data, index) => (
                                                                <div key={index}>
                                                                    <DetailsInput
                                                                        label={`${GeneralTranslations.type} ${WebsiteLanguage === 'sq' ? data.strLlojiDeklarimitPasurise : WebsiteLanguage === 'en' ? data.strLlojiDeklarimitPasuriseEn : data.strLlojiDeklarimitPasuriseSr}`}
                                                                        value={`${GeneralTranslations.description}: ${data.pershkrimi}`}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </Fragment>
                                                    ) : llojiShkeljes === "2" ? (
                                                        <Fragment>
                                                            <DetailsInput
                                                                label={GeneralTranslations.typeGift}
                                                                value={datatable.deklarimi.llojiDeklarimitTeDhuratave ? datatable.deklarimi.llojiDeklarimitTeDhuratave[pershkrimiLocale] : null}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.giftName}
                                                                value={datatable.deklarimi.pershkrimiDhurates}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.giftEuro}
                                                                value={datatable.deklarimi.vleraDhurates}
                                                            />
                                                            <DetailsInput
                                                                label={GeneralTranslations.timeGift}
                                                                value={datatable.deklarimi.dataPranimitDhurates ? dayjs(datatable.deklarimi.dataPranimitDhurates).format('DD/MM/YYYY') : null}
                                                            />
                                                        </Fragment>
                                                    ) : (
                                                        ''
                                                    )}
                                                    {datatable.raportimetMedia && datatable.raportimetMedia.length > 0 && (
                                                        <div className="details-docs">
                                                            <Title className="details-title cl-second mtw-5" order={5}>{GeneralTranslations.documents} </Title>
                                                            <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                                                <TableHead>
                                                                    <TableRow className="header-table">
                                                                        <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                                        <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                                        <TableCell className="header-th"></TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {datatable.raportimetMedia.map((doc, index) => (
                                                                        (doc.dokumentShtese === true || (doc.raportimetNeProcedureHetimoreId === null && doc.raportimiHistoriaId === null)) && (

                                                                            <TableRow key={index} className="body-table">
                                                                                <TableCell >{index + 1}</TableCell>
                                                                                <TableCell >{doc.emertimi}{doc.media.fileEx}</TableCell>
                                                                                <TableCell ><FiDownload className="cursor-pointer" onClick={() => onDownload(doc)} /></TableCell>
                                                                            </TableRow>
                                                                        )))}
                                                                </TableBody>
                                                            </Table>
                                                        </div>
                                                    )}
                                                </Fragment>
                                            )}
                                            {tjeraRaporte && (datatable && datatable.raportimetTjera) && (
                                                <Fragment>
                                                    {datatable.raportimetTjera.raportuesiAnonim !== true ? (
                                                        <Fragment>
                                                            {/* <DetailsInput
                                                                label={GeneralTranslations.isAnonymous}
                                                                value={datatable.raportimetTjera.raportuesiAnonim ? ControlsTranslations.yes : ControlsTranslations.no}
                                                            /> */}
                                                            {datatable.raportimetTjera.raportuesiEmri || datatable.raportimetTjera.raportuesiMbiemri ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.name}
                                                                            value={datatable.raportimetTjera.raportuesiEmri}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.lastName}
                                                                            value={datatable.raportimetTjera.raportuesiMbiemri}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            {datatable.raportimetTjera.raportuesiNrTel || datatable.raportimetTjera.raportuesiEmail ?
                                                                (
                                                                    <Group grow>
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.numriTelefonit}
                                                                            value={datatable.raportimetTjera.raportuesiNrTel}
                                                                        />
                                                                        <DetailsInput
                                                                            label={GeneralTranslations.emailAddress}
                                                                            value={datatable.raportimetTjera.raportuesiEmail}
                                                                        />
                                                                    </Group>
                                                                ) : ''
                                                            }
                                                            <DetailsInput
                                                                label={GeneralTranslations.gender}
                                                                type="Gender"
                                                                value={datatable.raportimetTjera.raportuesiGjiniaId}
                                                            />
                                                        </Fragment>
                                                    ) : ''}

                                                    <DetailsInput
                                                        label={GeneralTranslations.institutionLabel}
                                                        value={datatable.raportimetTjera.institucioni ? datatable.raportimetTjera.institucioni[nameLocale] : null}
                                                    />
                                                    {datatable.raportimetTjera.institucioniId === '-1' && (
                                                        <DetailsInput
                                                            label={GeneralTranslations.institutionName}
                                                            value={datatable.raportimetTjera.institucioniTjera}
                                                        />
                                                    )}
                                                    <DetailsInput
                                                        label={GeneralTranslations.caseDescription}
                                                        value={datatable.raportimetTjera.pershkrimi}
                                                    />
                                                    {datatable.raportimetMedia && datatable.raportimetMedia.length > 0 && (
                                                        <div className="details-docs">
                                                            <Title className="details-title cl-second mtw-5" order={5}>{GeneralTranslations.documents} </Title>


                                                            <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                                                <TableHead>
                                                                    <TableRow className="header-table">
                                                                        <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                                        <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                                        <TableCell className="header-th"></TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {datatable.raportimetMedia.map((doc, index) => (
                                                                        (doc.dokumentShtese === true || (doc.raportimetNeProcedureHetimoreId === null && doc.raportimiHistoriaId === null)) && (doc.publik === true) && (

                                                                            <TableRow key={index} className="body-table">
                                                                                <TableCell >{index + 1}</TableCell>
                                                                                <TableCell >{doc.emertimi}{doc.media.fileEx}</TableCell>
                                                                                <TableCell ><FiDownload className="cursor-pointer" onClick={() => onDownload(doc)} /></TableCell>
                                                                            </TableRow>
                                                                        )))}
                                                                </TableBody>
                                                            </Table>
                                                        </div>
                                                    )}
                                                </Fragment>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </Transition>
                            {/* )} */}

                            {/* Pjesa Komenteve Komentet */}
                            {Komentet && Komentet.length > 0 &&
                                <Comments onCommentPosted={handleCommentPosted} />
                            }
                        </div>
                    </div>
                )}
            </Transition>

        </div >
    )
}

export default Search